import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export type LeaderboardPeriod = 'monthly' | 'season' | 'alltime';

export interface LeaderboardRowDto {
  position: number;
  userId: string;
  displayName: string | null;
  email?: string;
  points: number;
}

export interface LeaderboardResponse {
  data: LeaderboardRowDto[];
  meta: { total: number; page: number; limit: number; totalPages: number; period: string };
}

export function useAdminLeaderboard(params: { period: LeaderboardPeriod; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['leaderboard', params],
    queryFn: async () => {
      const res = await apiClient.get<LeaderboardResponse>('/leaderboard', { params });
      return res.data;
    },
  });
}
